export const COMPANY = {
  name: "Prott Bauunternehmung",
  owner: "R. Sylka",
  street: "Werner-Heisenberg-Straße 2",
  city: "63263 Neu-Isenburg",
  phone: "0176-86715664",
  phoneHref: "tel:+4917686715664",
  email: "prott-bauunternehmung@web.de",
  emailHref: "mailto:prott-bauunternehmung@web.de",
  tax: "044 87362568",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8684942/pexels-photo-8684942.jpeg?auto=compress&cs=tinysrgb&w=1920",
  rohbau: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  umbau: "https://images.pexels.com/photos/17940311/pexels-photo-17940311.jpeg?auto=compress&cs=tinysrgb&w=1400",
  sanierung: "https://images.unsplash.com/photo-1765766601592-ac2936aa87e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  gartenbau: "https://images.unsplash.com/photo-1786958041678-ecf061354a86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  frankfurt: "https://images.pexels.com/photos/19336060/pexels-photo-19336060.jpeg?auto=compress&cs=tinysrgb&w=1920",
};

export const SERVICES = [
  {
    nr: "01",
    slug: "rohbau",
    title: "Rohbau",
    image: IMAGES.rohbau,
    claim: "Das Fundament jedes Bauwerks — präzise, massiv, termintreu.",
    desc: "Vom Erdarbeiten bis zum Rohbau abgeschlossener Gewerke: Wir erstellen tragende Strukturen in Stahlbeton- und Mauerwerksbauweise — vom Einfamilienhaus bis zum Geschosswohnungsbau mit 87 Wohneinheiten.",
    scope: ["Erdarbeiten & Gründungen", "Stahlbeton- & Mauerwerksarbeiten", "Geschosswohnungsbau", "Schlüsselfertige Rohbauten"],
  },
  {
    nr: "02",
    slug: "umbau",
    title: "Umbau",
    image: IMAGES.umbau,
    claim: "Bestand weiterdenken — Strukturen wandeln, Qualität bleiben.",
    desc: "Wir verwandeln Bestandsgebäude für neue Nutzungen: statische Eingriffe, Grundrissänderungen und Erweiterungen — von der Schule bis zum Gewerbeobjekt, im laufenden Betrieb koordiniert.",
    scope: ["Statische Eingriffe & Durchbrüche", "Nutzungsänderungen", "Erweiterungen & Anbauten", "Umbau im laufenden Betrieb"],
  },
  {
    nr: "03",
    slug: "sanierung",
    title: "Sanierung & Renovierung",
    image: IMAGES.sanierung,
    claim: "Zweites Leben für Gebäude — Substanz erhalten, Zukunft bauen.",
    desc: "Denkmalgeschützte Ikonen wie die Alte Oper Frankfurt oder Schulen und Sozialbauten: Wir sanieren mit Respekt vor der Substanz und dem Anspruch moderner Standards.",
    scope: ["Denkmalgerechte Sanierung", "Energetische Modernisierung", "Schul- & Sozialbau-Renovierung", "Instandsetzung von Fassaden & Tragwerk"],
  },
  {
    nr: "04",
    slug: "gartenbau",
    title: "Garten- & Landschaftsbau",
    image: IMAGES.gartenbau,
    claim: "Außenräume, die bleiben — vom Stadtquartier bis zum Grünzug.",
    desc: "Wir gestalten und bauen Außenanlagen für Wohnquartiere, Schulen und Gewerbe: Pflasterarbeiten, Begrünung, Spiel- und Aufenthaltsflächen — als komplette Außenanlage aus einer Hand.",
    scope: ["Außenanlagen für Quartiere", "Pflaster- & Wegebau", "Begrünung & Gestaltung", "Müllstellplätze & Infrastruktur"],
  },
];

export const PROJECTS = [
  { name: "BV Alte Oper Frankfurt", category: "Kultur & Denkmal", location: "Frankfurt am Main", highlight: true },
  { name: "BV GSI Darmstadt", category: "Forschung", location: "Darmstadt", highlight: true },
  { name: "BV Kaufland Pirmasens", category: "Gewerbe", location: "Pirmasens", highlight: true },
  { name: "BV Lyoner Str. 11 — Lyoner Quartier", category: "Wohnungsbau", location: "Frankfurt am Main", highlight: true },
  { name: "BV Geschosswohnungsbau 87 WE", category: "Wohnungsbau", location: "Weinheim" },
  { name: "BV Neubau von 87 Einfamilienreihenhäusern", category: "Wohnungsbau", location: "Langen" },
  { name: "BV Edith-Stein-Schule Offenbach", category: "Bildung", location: "Offenbach am Main" },
  { name: "BV Gesamtschule Gießen-Ost", category: "Bildung", location: "Gießen" },
  { name: "BV Grundschule Bockenheim", category: "Bildung", location: "Frankfurt am Main" },
  { name: "BV Fröbelschule Offenbach", category: "Bildung", location: "Offenbach am Main" },
  { name: "BV AWO Wilhelm-Hoegner-Haus", category: "Sozialbau", location: "Kitzingen" },
  { name: "BV KLEYERS Frankfurt", category: "Gewerbe", location: "Frankfurt am Main" },
  { name: "BV Marie-Juchacz-Str. — Hubland Neubaugebiet", category: "Wohnungsbau", location: "Würzburg" },
  { name: "BV Neubauprojekt Eichenheege", category: "Neubau", location: "Maintal" },
  { name: "BV Erneuerung Müllstellplätze", category: "Infrastruktur", location: "Eschborn" },
  { name: "BV Neubau 4 DHH", category: "Wohnungsbau", location: "Seeheim-Jugenheim" },
];

export const STATS = [
  { value: "30", suffix: "+", label: "Jahre Expertise" },
  { value: "16", suffix: "+", label: "Referenz-Bauvorhaben" },
  { value: "4", suffix: "", label: "Gewerke aus einer Hand" },
  { value: "100", suffix: "%", label: "Familiengeführt" },
];

export const NAV_LINKS = [
  { to: "/", label: "Start" },
  { to: "/leistungen", label: "Leistungen" },
  { to: "/projekte", label: "Projekte" },
  { to: "/ueber-uns", label: "Über uns" },
];
